import HourglassBottomIcon from '@mui/icons-material/HourglassBottom'
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import { useState } from 'react'
import { getFechaFromISO } from '../../../common/libs/fechas'
import FilesHelper from '../../../common/libs/Files'
import DocumentCard from './DocumentCard'

/**
 * Component that renders and download a document
 *
 * @param {Object} props
 * @param {DocumentacionDto} props.document - The document to show
 */
const DocumentacionCard = ({ document }) => {
  const [displayDocument, setDisplayDocument] = useState(document)
  const tags = [].concat(displayDocument?.d_tag ?? [])
  console.log(tags)
  return (
    <DocumentCard
      title={displayDocument?.titulo}
      readDate={displayDocument?.descargado}
      content={
        <List
          sx={{ width: '100%' }}
          dense={true}>
          {displayDocument?.observaciones ? (
            <ListItem>
              <ListItemText primaryTypographyProps={{ style: { color: 'blue' } }}>
                <div
                  dangerouslySetInnerHTML={{ __html: displayDocument?.observaciones || '' }}
                  style={{ color: 'blue' }}
                />
              </ListItemText>
            </ListItem>
          ) : (
            <></>
          )}
          {displayDocument?.fecha_baja ? (
            <ListItem>
              <ListItemIcon>
                <HourglassBottomIcon sx={{ color: 'red' }} />
              </ListItemIcon>
              <ListItemText
                primary={'Caduca el ' + getFechaFromISO(displayDocument?.fecha_baja)}
                primaryTypographyProps={{ style: { color: 'red' } }}
                //secondary='Fecha publicación'
              />
            </ListItem>
          ) : null}
          {displayDocument?.id &&
          displayDocument?.tipo_doc &&
          document.tipo_doc > 0 &&
          displayDocument.nombre_archivo != null ? (
            <List
              sx={{ width: '100%' }}
              dense={true}>
              <ListItem>
                <ListItemText sx={{ color: '#777777' }}>
                  <p>
                    <a
                      href='#'
                      onClick={async e => {
                        e.preventDefault()
                        await FilesHelper.downloadFile(
                          displayDocument.id,
                          document.tipo_doc,
                          document.url,
                        ).finally(() => {
                          const date = new Date().toISOString()
                          setDisplayDocument({ ...displayDocument, descargado: date })
                        })
                      }}>
                      Descargar / Download
                    </a>
                  </p>
                </ListItemText>
              </ListItem>
            </List>
          ) : (
            <></>
          )}
        </List>
      }
      forced={displayDocument?.lectura_obligatoria}
      MIMEType={displayDocument?.mime_type}
      subtitle={displayDocument?.d_categoria}
      img_title={displayDocument?.portada_nombre}
      chip={tags}
    />
  )
}

export default DocumentacionCard
